import React, { useEffect, useState } from 'react'
import { Disclosure} from '@headlessui/react'
import { Bars3Icon, XMarkIcon} from '@heroicons/react/24/outline'
import { NavLink } from 'react-router-dom'



function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navbar({ user }) {

    const [loggedIn, setLoggedIn] = useState(false)

    const [navigation, setNavigation] = useState([
        { name: 'Start', href: '/', current: true },
        { name: 'Logga in', href: '/login', current: false }
    ])


    const handleNavigation = (item) => {
        const newNavState = navigation.map(nav => {
            if (nav === item) {
                nav.current = true
                return nav
            }
            nav.current = false
            return nav
        })
        setNavigation(newNavState)
    }


    // useEffect(() => {
       
    //     if (user.loggedIn) {
    //         console.log(user)
    //         setLoggedIn(true)
    //     }
    //     else {
    //         setLoggedIn(false)
    //     }


    // }, [user])






    return (
        <Disclosure as="nav" className="dark:bg-transparent bg-white-800">
            {({ open }) => (
                <>
                    <div className="mx-auto px-2 container">
                        <div className="relative flex h-16 items-center justify-between">
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                {/* Mobile menu button*/}
                                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    <span className="absolute -inset-0.5" />
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                                <div className="flex flex-shrink-0 items-center">
                                    <img
                                        className="h-12 w-auto"
                                        src="\Kopia av logga white.png"
                                        alt="Your Company"
                                    />
                                </div>
                                <div className="hidden sm:ml-3 sm:block">
                                    <div className="flex h-12 space-x-4">
                                        {navigation.map((item) => {
                                            if (item.name === 'Logga in') {
                                                if (user.loggedIn) return

                                                return (<NavLink
                                                    onClick={(e) => handleNavigation(item)}
                                                    key={item.name}
                                                    to={item.href}
                                                    className={classNames(
                                                        item.current ? 'my-auto dark:bg-gray-900 dark:text-white bg-zinc-300 text-black hover:bg-gray-500' : 'my-auto dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white hover:bg-gray-500 hover:text-black',
                                                        'rounded-md px-3 py-2 text-sm font-medium'
                                                    )}
                                                    aria-current={item.current ? 'page' : undefined}
                                                >
                                                    {item.name}
                                                </NavLink>)
                                            }
                                            else {
                                                return (<NavLink
                                                    onClick={(e) => handleNavigation(item)}
                                                    key={item.name}
                                                    to={item.href}
                                                    className={classNames(
                                                        item.current ? 'my-auto dark:bg-gray-900 dark:text-white bg-zinc-300 text-black hover:bg-gray-500' : 'my-auto dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white hover:bg-gray-500 hover:text-black',
                                                        'rounded-md px-3 py-2 text-sm font-medium'
                                                    )}
                                                    aria-current={item.current ? 'page' : undefined}
                                                >
                                                    {item.name}
                                                </NavLink>)
                                            }
                                        }
                                        )}
                                        <div className='justify-center content-center m-0 p-0'>

                                        {user.loggedIn && <span className='text-gray-300 align-middle m-0 p-0'>Välkommen {user.firstName}!</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                                {/* <button
                                    onClick={handleDarkMode}
                                    type="button"
                                    className="relative rounded-full h-8 w-8 dark:bg-zinc-300 bg-gray-800 dark:text-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                                >
                                    <span className="absolute -inset-1.5" />
                                    <span className="sr-only">View notifications</span>
                                    <NightIcon className="h-6 w-6" aria-hidden="true" />
                                    {!darkMode ? <i className="fa-regular fa-moon h-6 w-6"></i> : <i className="fa-solid fa-sun"></i>}

                                </button> */}



                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden">
                        <div className="space-y-1 px-2 pb-3 pt-2">
                            {navigation.map((item) => {
                                if (item.name === "Logga in") {
                                    if (user.loggedIn) return

                                    return (<NavLink
                                        onClick={(e) => handleNavigation(item)}
                                        key={item.name}
                                        to={item.href}
                                        className={classNames(
                                            item.current ? 'dark:bg-gray-900 dark:text-white bg-zinc-300 block text-black hover:bg-gray-500' : 'dark:text-gray-300 block dark:hover:bg-gray-700 dark:hover:text-white hover:bg-gray-500 hover:text-black',
                                            'rounded-md px-3 py-2 text-sm font-medium'
                                        )}
                                        aria-current={item.current ? 'page' : undefined}
                                    >
                                        {item.name}
                                    </NavLink>)
                                }
                                else {
                                    return (<NavLink
                                        onClick={(e) => handleNavigation(item)}
                                        key={item.name}
                                        to={item.href}
                                        className={classNames(
                                            item.current ? 'dark:bg-gray-900 dark:text-white bg-zinc-300 block text-black hover:bg-gray-500' : 'dark:text-gray-300 block dark:hover:bg-gray-700 dark:hover:text-white hover:bg-gray-500 hover:text-black',
                                            'rounded-md px-3 py-2 text-sm font-medium'
                                        )}
                                        aria-current={item.current ? 'page' : undefined}
                                    >
                                        {item.name}
                                    </NavLink>)
                                }
                            })}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}
